var _clipPath, _clipPath2, _clipPath3, _clipPath4, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _radialGradient, _radialGradient2, _radialGradient3, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChromeDev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 5600 5600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2800,
    cy: 2800,
    r: 2600
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#N"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613 200v1192l1164 1999 1023-1773h2600V200z"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 830,
    x2: 2382.5,
    y1: 2180,
    y2: 1275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a52714",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 3240,
    x2: 1515,
    y1: 4822.5,
    y2: 3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#055524",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 3565,
    x2: 3997.5,
    y1: 1435,
    y2: 3335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ea6100",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 760.5,
    cy: -79.7,
    r: 99.4,
    gradientTransform: "matrix(25 0 0 -25 -16325 -375)",
    xlinkHref: "#a"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 677.4,
    cy: -70.9,
    r: 92.2,
    gradientTransform: "matrix(25 0 0 -25 -16325 -375)",
    xlinkHref: "#a"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 764.8,
    cy: -127.2,
    r: 103.8,
    gradientTransform: "matrix(25 0 0 -25 -16325 -375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db4437",
    d: "M613 200v3191h1164l1023-1773h2600V200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M613 200v3191h1164l1023-1773h2600V200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    fillOpacity: 0.15,
    d: "M1805 3381L628 1362l-17 30 1168 2003z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0f9d58",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M200 5400h2475l1149-1149v-860H1777L200 687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.15,
    d: "M3800 3430l-25-14-1134 1984h34l1126-1969z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#ffcd40",
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M2800 1618l1024 1773-1149 2009h2725V1618z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#ffcd40",
    xlinkHref: "#N"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M2800 1618l1024 1773-1149 2009h2725V1618z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db4437",
    d: "M613 200v3191h1164l1023-1773h2600V200z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M613 200v3191h1164l1023-1773h2600V200z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M2800 1618v619l2316-619z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0f9d58",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M200 5400h2475l1149-1149v-860H1777L200 687z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M613 1395l1691 1691-527 305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M2677 5397l619-2311 528 305z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2800,
    cy: 2800,
    r: 1182,
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2800,
    cy: 2800,
    r: 945,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e2723"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.2,
    d: "M2800 1589c-653 0-1182 529-1182 1182v29c0-653 529-1182 1182-1182h2600v-30H2800z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M3822 3391c-204 353-585 591-1022 591s-818-238-1023-591h-1L200 687v30l1577 2703h1c204 353 585 591 1023 591 437 0 818-238 1022-591h1v-30h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 1618c-5 0-10 1-15 1 646 8 1167 533 1167 1181s-521 1173-1167 1181c5 0 10 1 15 1 653 0 1182-529 1182-1182s-530-1182-1182-1182z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M3834 3430c100-174 159-375 159-590 0-125-19-245-55-357a1170.4 1170.4 0 01-115 907l1 1-1149 2009h34l1125-1969z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M2800 230c1431 0 2592 1156 2600 2585v-15c0-1436-1164-2600-2600-2600S200 1364 200 2800v15c8-1429 1169-2585 2600-2585z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M2800 5370c1431 0 2592-1156 2600-2585v15c0 1436-1164 2600-2600 2600S200 4236 200 2800v-15c8 1429 1169 2585 2600 2585z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M112 3231h5450v2281H112z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1988 4470v-716h219c110 0 198 33 264 99s99 153 99 258c0 106-33 192-99 258s-154 100-264 100h-219zm92-88h127c83 0 148-24 197-71s72-114 72-199-24-151-72-198-114-71-197-71h-127zm790 104c-74 0-134-25-180-74s-70-112-70-187c0-71 22-133 67-184s103-77 173-77c73 0 131 24 174 71s66 111 66 190l-1 17h-387c3 49 19 88 50 117 30 29 66 43 106 43 66 0 111-28 134-84l82 34c-16 38-42 70-79 96-37 25-82 38-135 38zm132-320c-2-28-15-55-39-80s-59-38-105-38c-34 0-63 11-88 32s-42 50-52 86zm318 304l-198-490h100l144 380h2l146-380h98l-200 490z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M200 5400h2475l1149-1149v-860H1777L200 687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M2800 1618l1024 1773-1149 2009h2725V1618z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeDev);
export default __webpack_public_path__ + "static/media/chrome-dev.54b35d4f8c68707074fa43f72473545a.svg";
export { ForwardRef as ReactComponent };